import { render, staticRenderFns } from "./SupportCommunicationsHeader.vue?vue&type=template&id=f981db3e&"
import script from "./SupportCommunicationsHeader.vue?vue&type=script&lang=js&"
export * from "./SupportCommunicationsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports